module.exports = __webpack_public_path__ + "static/media/Export.935cc13b.svg";